// extracted by mini-css-extract-plugin
module.exports = {"badge":"_badge--1bZz3"};